// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"105":"11524cea43bff97aff41","496":"cf9304d87fed5cda01ac","765":"6c4e69499497b027d855"}[chunkId] + ".js";
};